<template>
    <div class="share_box" id="share_box">
        <div class="share-head">
            <div class="head-item"><img src="@/assets/productShare/right-icon.png" /><span>阳光行程</span></div>
            <div class="head-item"><img src="@/assets/productShare/right-icon.png" /><span>阳光价格</span></div>
            <div class="head-item"><img src="@/assets/productShare/right-icon.png" /><span>阳光服务</span></div>
        </div>
        <div class="content">
            <div class="img-box">
                <img class="top_img" :src="getFilePath(coverImage)" />
                <div class="img-tip">热卖{{ type }}</div>
            </div>
            <div class="name-price">
                <div class="user-name">
                    <div class="user-icon"><img :src="headimgurl" class="userImg" /></div>
                    <div class="user_name">{{ name }}</div>
                </div>
                <div class="price-text">&yen;{{ minprice }}</div>
            </div>
            <div class="product-name-box">
                <div class="product-name">
                    <div v-for="text in productNameList">{{ text }}</div>
                </div>
            </div>
        </div>
        <div class="share-code-desc">
            <div class="left">
                <div class="desc">{{desc}}</div>     
                <div class="tips">
                    <span class="hot">热卖中</span>
                    <span class="code-text">长按识别 →</span>
                </div>
            </div>  
            <canvas class="qrcode" id="qrcode"></canvas>  
        </div>
    </div>
</template>

<script>
// import QRCode from 'qrcodejs2'
import QRCode from "qrcode";
import html2canvas from '../../utils/html2canvas'
// import html2canvas from "html2canvas";
import { getImgUrl } from '../../mixins/getImgUrl'
import { Toast } from 'vant'
import qs from 'qs'

export default {
    name: 'product-share',
	props: [
        'coverImage',
        'productName',
        'price',
        'sharePayFlag',
        'minprice',
        'shareUrl',
        'desc',
        'type'
    ],
	mixins: [getImgUrl],
    data() {
        return {
            headimgurl: '',
            name: ''
        }
    },
    computed: {
        productNameList(){
            const productName = this.productName.replace(/[\r\n]/g, '');
            const str = productName>34 ? productName.substr(0, 34) + '...': productName;
            const arr = str.split('');
            return arr
        }
    },
    mounted() {
        const wechatUser = JSON.parse(localStorage.getItem('wechatUser')) || {}
		this.headimgurl = wechatUser.headimgurl
        const user = this.$store.state.userInfo_v2?.user
        const flag = localStorage.getItem('flag')
		if (user && flag === 'false') {
			// this.name = user.userName
			this.name = wechatUser.nickname
		} else {
			this.name = wechatUser.nickname
		}
        this.createQRCode();
    },
    methods: {
        createQRCode() {
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: "加载中...",
            });
           const host = location.href.split("shop/")[0];
           var userInfo_v2 = JSON.parse(localStorage.userInfo_v2)
            // var text = host + "shop" + this.shareUrl + `&sharedUserId=${userInfo_v2.user.userId}`;
            var text = host + "shop" + this.shareUrl;
            let canvas = document.getElementById('qrcode');
            QRCode.toCanvas(canvas, text, (error) => {
                if (error) {
                    console.log(error)
                } else {
                    canvas.style.width = 140 * (document.documentElement.clientWidth / 750) + 'px';
                    canvas.style.height = 140 * (document.documentElement.clientWidth / 750) + 'px';

                    setTimeout(async() => {
                        let shareCard = document.getElementById("share_box");
                        (window.html2canvas || html2canvas)(shareCard, {
                            allowTaint: true,
                            useCORS: true,
                            scrollY: 0,
                        }).then((canvas) => {
                            const width = 660 * (document.documentElement.clientWidth / 750);
                            const height = 1100 * (document.documentElement.clientWidth / 750);
                            const tempImg = document.createElement('img');
                            tempImg.src = canvas.toDataURL();
                            tempImg.width  = width;
                            tempImg.height = height;
                            tempImg.alt = "分享海报";
                            tempImg.style.borderRadius = '6px'
                            document.getElementById("share_box").innerHTML = '';
                            document.getElementById("share_box").appendChild(tempImg);
                            Toast.clear()
                            });
                    }, 0)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.share_box {
    position: relative;
    background: url('../../assets/productShare/share_bk.png') no-repeat;
    background-size:100% 100%;
    height: 100%;
    // background-color: #fff;
    // border-radius: vw(12);

    ::v-deep .text {
		text-align: center;
		color: #fff;
		font-weight: 700;
		letter-spacing: 0.2em;
	}
    .share-head {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: vw(30) 0;
        .head-item {
            display: flex;
            align-items: center;
            img {
                width: vw(22);
                height: vw(22);
            }
            span {
                font-size: vw(26);
                color: #FFFFFF;
                margin-left: vw(8);
            }
        }
    }
    .content {
        margin: 0 vw(30);
        background: url('../../assets/productShare/content-bk.png') no-repeat;
        background-size: cover;
        // height: vw(700);
        .img-box {
            position: relative;
            margin: 0 vw(20);
            padding-top: vw(20);
            border-radius: vw(18);
            .top_img {
                width: vw(560);
                height: vw(564);
                object-fit: cover;
                border-radius: vw(18);
                // border-top-left-radius: vw(12);
                // border-top-right-radius: vw(12);
            }
            .img-tip {
                position: absolute;
                width: vw(140);
                height: vw(44);
                top: vw(20);
                left: 0;
                color: #fff;
                font-size: vw(26);
                background: url('../../assets/productShare/title-bg.png') no-repeat;
                background-size: 100% 100%;
                text-align: center;
                line-height: vw(44);
            }
        }
        .name-price {
            display: flex;
            justify-content: space-between;
            margin: 0 vw(20);
            align-items: center;
            position: relative;
            height: vw(88);
            .user-name {
                display: flex;
                align-items: center;
                .user-icon {
                    margin-top: vw(-44);
                    background: #fff;
                    border-radius: 50%;
                    padding: vw(10);
                    position: absolute;
                    .userImg {
                        width: vw(88);
                        height: vw(88);
                        border-radius: 50%;
                    }
                }
                .user_name {
                    font-size: vw(26);
                    color: #8592A6;
                    margin-left: vw(118);
                }
            }
            .price-text {
                font-size: vw(36);
                color: #FF3333;
            }
        }
        .product-name-box {
            margin: 0 vw(30);
            padding-bottom: vw(20);
            .product-name {
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                align-items: center;
                // overflow: hidden;
                // text-overflow: ellipsis;
                // display: -webkit-box;
                // -webkit-line-clamp: 2;
                // -webkit-box-orient: vertical;
                // display: -moz-box;
                // -moz-line-clamp: 2;
                // -moz-box-orient: vertical;
                // word-wrap: break-word;
                // word-break: break-all;
                font-weight: 700;
                color: #333;
                font-size: vw(30);
            }
        }
        
		
        .product-code {
            display: flex;
            justify-content: space-between;
            padding: vw(0) vw(30);
            margin-top: vw(30);
            .product-name {
                font-weight: 700;
                font-size: vw(28);
                color: #333333;
                letter-spacing: 0;
                width: calc(vw(600) - vw(210));
            }
            
        }
    }
    .share-code-desc {
        display: flex;
        justify-content: space-between;
        margin: vw(15) vw(30) 0 vw(30);
        background: #fff;
        padding: vw(20);
        border-radius: vw(12);
        .left {
            .desc {
                font-size: vw(24);
                color: #8592A6;
            }
            .tips {
                border: 1px solid #3377FF;
                width: vw(260);
                font-size: vw(24);
                border-radius: vw(23);
                margin-top: vw(20);
                .hot {
                    display: inline-block;
                    background: #3377FF; 
                    border-radius: vw(23);
                    height: vw(40);
                    color: #fff;
                    width: vw(108);
                    text-align: center;
                    line-height: vw(40);
                }
                .code-text {
                    color: #3377FF;
                    margin-left: vw(10);
                }
            }
        }
    }
}
</style>